var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgEmergencyPass(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 77,
    viewBox: "0 0 101 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 15.001,
    width: 100,
    height: 62,
    rx: 4,
    fill: "#FF7D23"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 15.001,
    width: 96,
    height: 57,
    rx: 4,
    fill: "#FFEADB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 55.001,
    width: 22,
    height: 3,
    rx: 1.5,
    fill: "#FDBD90"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 24.001,
    width: 22,
    height: 3,
    rx: 1.5,
    fill: "#FDBD90"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 61.001,
    width: 28,
    height: 3,
    rx: 1.5,
    fill: "#FDBD90"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 29.6606H45.5071V33.3529H38V29.6606Z",
    fill: "#E62645"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4932 29.6606H101V33.3529H93.4932V29.6606Z",
    fill: "#E62645"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.168 13.2292L90.3862 8.01099L93.0021 10.6269L87.7839 15.8451L85.168 13.2292Z",
    fill: "#E62645"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.229 15.8451L46.0107 10.6269L48.6267 8.01099L53.8449 13.2292L51.229 15.8451Z",
    fill: "#E62645"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6611 0H71.3534V7.50714H67.6611V0Z",
    fill: "#E62645"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8915 55.6289C50.8478 55.6289 49.1992 57.2775 49.1992 59.3212V63.0134H89.8141V59.3212C89.8141 57.2775 88.1655 55.6289 86.1218 55.6289H52.8915Z",
    fill: "#A7163E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8916 31.5V51.9232H86.1219V31.5C86.1219 22.3442 78.6693 14.8916 69.5136 14.8916C60.3579 14.8916 52.8916 22.3442 52.8916 31.5ZM67.6606 25.9684H71.3529V37.0451H67.6606V25.9684ZM67.6606 40.7374H71.3529V44.4297H67.6606V40.7374Z",
    fill: "#E62645"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgEmergencyPass);
export default __webpack_public_path__ + "static/media/imgEmergencyPass.da25269ca00c742856d3a05fc308ecbf.svg";
export { ForwardRef as ReactComponent };